import {
  View,
  Text,
  Dimensions,
  Image,
  TouchableOpacity,
  Platform,
} from "react-native";
import React from "react";
import {
  danger,
  femaleColor,
  gray,
  green,
  maleColor,
  primary,
  success,
  white,
} from "../../colors";
import { testChildren, tests, tutorial } from "../../imports";
import translate from "../../functions/translate";
import MyText from "../../components/custom/MyText";
import { useDispatch, useSelector } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import { changeHeaderColor } from "../../redux/header/headerAction";
import { useEffect } from "react";
import { useState } from "react";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import TestItem from "../../components/test/TestItem";
import Header from "../../components/header/Header";
import { ScrollView } from "react-native-gesture-handler";
import MyButton from "../../components/custom/MyButton";
import ProgressBar from "../../components/custom/ProgressBar";
import BackIcon from "../../assets/svg/BackIcon";
import TextExplainIcon from "../../assets/svg/TextExplainIcon";
import VideoExplainIcon from "../../assets/svg/VideoExplainIcon";
import TestQuestionSelectAnswer from "../../components/test/TestQuestionSelectAnswer";
import TestQuestionTextExplanation from "../../components/modals/TestQuestionTextExplanation";
import {
  setTestQuestionTextExplanation,
  setTestQuestionVideoExplanation,
} from "../../redux/modal/modalAction";
import TestQuestionVideoExplanation from "../../components/modals/TestQuestionVideoExplanation";
import BackButtonInTest from "../../components/test/BackButtonInTest";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

export default function TestQuestion(props) {
  const testDetail = props.route.params;

  const navigation = useNavigation();
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [selectedChild, setChild] = useState({ gender: "male", name: "ahmad" });
  const [answer, setAnswer] = useState(null);
  const [questionScore, setQuestionScore] = useState({ id: 0, score: 0 });

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#F7F7F7"));
    }
  }, [isFocused]);
  useEffect(() => {}, []);
  const currentQuestion = testDetail.test[testDetail.questionNumber - 1];
  const videoUrl = main.rtl
    ? currentQuestion.linkUrlEN
    : currentQuestion.linkUrlFa;
  const explainText = main.rtl
    ? currentQuestion.descreptionsFa
    : currentQuestion.descreptionsEn;

  return (
    <View style={{ flex: 1, alignItems: "center" }}>
      <View style={{ width: "100%" }}>
        <Header notOpenDrawer={true} />
      </View>
      <BackButtonInTest />
      <KeyboardAwareScrollView
        enableOnAndroid={true}
        extraHeight={200}
        contentContainerStyle={{ alignItems: "center" }}
        style={{ flex: 1 }}
      >
        {explainText !== undefined &&
          explainText !== null &&
          explainText !== "" && (
            <TestQuestionTextExplanation text={explainText} />
          )}
        {videoUrl !== undefined && videoUrl !== null && videoUrl !== "" && (
          <TestQuestionVideoExplanation url={videoUrl} />
        )}

        <View
          style={{
            width: "100%",
            alignItems: "center",
            flex: 1,
          }}
        >
          <View style={{ alignItems: "center" }}>
            <View
              style={{
                height: Dimensions.get("window").height,
                marginTop: -1 * Dimensions.get("window").height,
                backgroundColor: "#F7F7F7",
                width: "100%",
              }}
            ></View>
            <View style={{ alignItems: "center" }}>
              <View style={{ backgroundColor: "#F7F7F7" }}>
                <View
                  style={{
                    backgroundColor: "#F7F7F7",
                    justifyContent: "center",

                    zIndex: 10,
                    width: Dimensions.get("screen").width,
                    minHeight: 200,
                    flexDirection: "row",
                    paddingHorizontal: 10,
                  }}
                >
                  <View style={{ flex: 1, alignItems: "center", marginTop: 5 }}>
                    <View
                      dir={main.rtl ? "rtl" : "ltr"}
                      style={{ width: "90%" }}
                    >
                      <View
                        dir={main.rtl ? "rtl" : "ltr"}
                        style={{ flexDirection: "row" }}
                      >
                        <MyText style={{ color: gray }}>
                          {`${testDetail.questionNumber}`}
                        </MyText>
                        <MyText style={{ marginHorizontal: 3, color: gray }}>
                          {translate("from")}
                        </MyText>
                        <MyText
                          style={{ color: gray }}
                        >{`${testDetail.test.length}`}</MyText>
                      </View>
                      <ProgressBar
                        progress={
                          (testDetail.questionNumber / testDetail.test.length) *
                          100
                        }
                        color={green}
                      />
                    </View>
                    {testDetail.questionNumber !== 1 && (
                      <TouchableOpacity
                        onPress={() =>
                          navigation.replace("TestQuestion", {
                            questionNumber: testDetail.questionNumber - 1,
                            test: testDetail.test,
                            answer: testDetail.answer.filter(
                              (answer) => currentQuestion.id !== answer.id
                            ),
                            type: testDetail.type,
                            part: testDetail.part,
                            userDetails: testDetail.userDetails,
                          })
                        }
                        style={{
                          width: "90%",
                          flexDirection: "row",
                          marginTop: 5,
                          alignItems: "center",
                        }}
                        dir={main.rtl ? "rtl" : "ltr"}
                      >
                        <View
                          style={{
                            transform: [
                              { scale: 0.8 },
                              { rotate: main.rtl ? "0deg" : "180deg" },
                            ],
                          }}
                        >
                          <BackIcon />
                        </View>
                        <MyText style={{ marginHorizontal: 3, color: "#aaa" }}>
                          {translate("previous question")}
                        </MyText>
                      </TouchableOpacity>
                    )}
                    <View style={{ marginTop: 15, width: "90%" }}>
                      <Text
                        style={{
                          fontWeight: "bold",
                          fontSize: 15,
                          writingDirection: main.rtl ? "rtl" : "ltr",
                        }}
                      >
                        {`${
                          main.rtl
                            ? currentQuestion.titleFa
                            : currentQuestion.titleEn
                        }`}
                      </Text>
                    </View>
                    <View style={{ flex: 1 }}></View>
                    <View
                      style={{
                        width: "90%",
                        marginTop: 15,
                        marginBottom: 10,
                      }}
                    >
                      {explainText !== undefined &&
                        explainText !== null &&
                        explainText !== "" && (
                          <TouchableOpacity
                            onPress={() =>
                              dispatch(setTestQuestionTextExplanation())
                            }
                            style={{ flexDirection: "row" }}
                          >
                            <TextExplainIcon />
                            <MyText style={{ marginHorizontal: 5 }}>
                              {translate("text explain")}
                            </MyText>
                          </TouchableOpacity>
                        )}
                      {videoUrl !== undefined &&
                        videoUrl !== null &&
                        videoUrl !== "" && (
                          <TouchableOpacity
                            onPress={() =>
                              dispatch(setTestQuestionVideoExplanation())
                            }
                            style={{ flexDirection: "row", marginTop: 7 }}
                          >
                            <VideoExplainIcon />
                            <MyText style={{ marginHorizontal: 5 }}>
                              {translate("video explain")}
                            </MyText>
                          </TouchableOpacity>
                        )}
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View style={{ flex: 1, width: "100%", alignItems: "center" }}>
            {(currentQuestion.typeOfQuestion === "test" ||
              currentQuestion.typeOfQuestion === "multi") && (
              <View
                style={{ width: "90%", alignItems: "center", marginTop: 10 }}
              >
                {currentQuestion.responsItem.map((questionAnswer, index) => (
                  <TestQuestionSelectAnswer
                    key={index}
                    text={
                      main.rtl ? questionAnswer.titleFa : questionAnswer.titleEn
                    }
                    selected={
                      answer ===
                      (main.rtl
                        ? questionAnswer.titleFa
                        : questionAnswer.titleEn)
                    }
                    onPress={() => {
                      setAnswer(
                        main.rtl
                          ? questionAnswer.titleFa
                          : questionAnswer.titleEn
                      );
                      setQuestionScore({
                        number: testDetail.questionNumber,
                        id: currentQuestion.id,
                        score: questionAnswer.score,
                        answer: main.rtl
                          ? questionAnswer.titleFa
                          : questionAnswer.titleEn,
                      });
                    }}
                  />
                ))}
              </View>
            )}
            {currentQuestion.typeOfQuestion !== "test" && (
              <View style={{ flex: 1, width: "100%", alignItems: "center" }}>
                <MyInputWithLabel
                  setInput={() => {}}
                  setAnswer={(text) => {
                    setAnswer(text);
                    setQuestionScore({
                      id: currentQuestion.id,
                      answer: text,
                      number: testDetail.questionNumber,
                    });
                  }}
                />
              </View>
            )}
          </View>
        </View>
      </KeyboardAwareScrollView>
      <View
        style={{
          width: "90%",
          alignItems: "center",
          marginBottom: Platform.OS === "ios" ? 40 : 10,
        }}
      >
        <MyButton
          onPress={() =>
            answer !== null || answer === ""
              ? testDetail.questionNumber !== testDetail.test.length
                ? navigation.replace("TestQuestion", {
                    questionNumber: testDetail.questionNumber + 1,
                    test: testDetail.test,
                    answer: [...testDetail.answer, { ...questionScore }],
                    type: testDetail.type,
                    part: testDetail.part,
                    userDetails: testDetail.userDetails,
                  })
                : navigation.navigate("AnswerReview", {
                    test: testDetail.test,
                    type: testDetail.type,
                    answer: [...testDetail.answer, { ...questionScore }],
                    part: testDetail.part,
                    userDetails: testDetail.userDetails,
                  })
              : null
          }
          textStyle={{
            color: answer === null || answer === "" ? green : white,
          }}
          text={
            testDetail.questionNumber === testDetail.test.length
              ? translate("next step")
              : translate("next question")
          }
          style={{
            backgroundColor: answer === null || answer === "" ? white : green,
            paddingVertical: 15,
            borderColor: green,
            borderWidth: 1,
            width: "100%",
          }}
        />
        {testDetail.answer.length >= testDetail.questionNumber - 2 && (
          <TouchableOpacity
            onPress={() =>
              testDetail.questionNumber !== testDetail.test.length
                ? navigation.replace("TestQuestion", {
                    questionNumber: testDetail.questionNumber + 1,
                    test: testDetail.test,
                    answer: [...testDetail.answer],
                    type: testDetail.type,
                    part: testDetail.part,
                    userDetails: testDetail.userDetails,
                  })
                : navigation.navigate("AnswerReview", {
                    test: testDetail.test,
                    type: testDetail.type,
                    answer: [...testDetail.answer],
                    part: testDetail.part,
                    userDetails: testDetail.userDetails,
                  })
            }
          >
            <MyText style={{ marginTop: 10, color: danger }}>
              {translate("skip question")}
            </MyText>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}
